module.exports = __webpack_public_path__ + "static/1-924a82fa2baa11f1097b046d4e3bbee8.jpg";